import { api, errMsg } from "@/lib/api";

export const transcribeAudio = async (blob, filename) => {
  const form = new FormData();
  form.append("audio", blob, filename);
  try {
    const { data } = await api.post("/poc/transcribe", form, { timeout: 180000 });
    return data;
  } catch (e) {
    throw new Error(errMsg(e));
  }
};

export const extractText = async (text, runId) => {
  try {
    const { data } = await api.post("/poc/extract", { text, run_id: runId || null }, { timeout: 180000 });
    return data;
  } catch (e) {
    throw new Error(errMsg(e));
  }
};
